import { ErrorHandler, Injectable } from "@angular/core";
import { MobileAuthStore } from "../state/mobile-auth.store";

@Injectable()
export class MobileGlobalErrorHandler implements ErrorHandler {
  constructor(private readonly authStore: MobileAuthStore) {}

  handleError(error: unknown): void {
    const message = error instanceof Error ? error.message : "Unhandled mobile error";
    this.authStore.setError(message);
    // Keep default behavior for diagnostics in dev tools.
    // eslint-disable-next-line no-console
    console.error(error);
  }
}
